// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"177":"home","186":"juz","237":"tafsir","839":"surah"}[chunkId] + "." + {"177":"8f331a11","186":"4d3b94be","237":"b6b9feae","839":"c4f61c23"}[chunkId] + ".css";
};